import { useMemo } from 'react';
import { useOnboardingMembers } from './useOnboardingMembers';
import { UserExperiencePlanType } from './useUserExperience';

export const useNpOnboardingMembers = () => {
  const onboardingMembers = useOnboardingMembers();

  const npOnboardingMembers = useMemo(() => {
    return (
      onboardingMembers.filter((m) => m.plans.includes(UserExperiencePlanType.NP) && m.unfinishedNpOnboarding) || []
    );
  }, [onboardingMembers]);

  return npOnboardingMembers;
};
